import { Component } from "@angular/core";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { LoaderService } from './services/loader.service'
import { MessageService } from './services/message.service'
import { UserService } from './services/user.service'
import { SharedModule } from './shared.module'


@Component({
    selector: 'app-admin',
    templateUrl: '/admin.component.html'
})

export class AdminComponent{

    //loading: boolean = false;
    loadingAutocomplete: boolean = true;
    myDataShops: any;
    shopLoginMessage: string = "";
    messageClass: string = "";
    dispTools: boolean = false;
    dispCitipostOnly: boolean = false;
    dispPlaceOrder: boolean = false;
  dispReports: boolean = false;
  dispHelpDesk: boolean = false;
  welcome: string = "";
 
    constructor(public http: HttpClient, public router: Router, private loaderService: LoaderService, private userService: UserService ) {
      this.userService.welcome().subscribe(data => this.welcome = data);// user name

    }

    launchShop(shop: any) {
        localStorage.setItem("Shop", shop.Id);
        this.router.navigate(['/shopservices']);
  }


  launchHelpDesk() {
    localStorage.removeItem("Shop");
    sessionStorage.removeItem('shopData');
    this.router.navigate(['/specsavers/helpdesk']);
  }

    loadShops() {
        this.loaderService.emitChange(true);
        this.loadingAutocomplete = true;
        var myUrl: string = '/Resources2/ShopsList';
        this.http.get(myUrl).subscribe((res: any) => {
                this.myDataShops = res;
                 this.loaderService.emitChange(false);
            });
    }

    isRole(){
      
      this.userService.role().subscribe((res : any) => {
          switch (res) {
          case "citipostsuperadmin":
              this.dispReports = true;
              this.dispTools = true;
              this.dispCitipostOnly = true;
              this.dispPlaceOrder = true;
              this.dispHelpDesk = false;
          break;
          case "citipostadmin":
              this.dispReports = true;
              this.dispTools = false;
              this.dispCitipostOnly = false;
              this.dispPlaceOrder = true;
              this.dispHelpDesk = false;
              break;
            case "specsaversadmin":
              this.dispReports = false;
              this.dispTools = true;
              this.dispCitipostOnly = false;
              this.dispPlaceOrder = false;
              this.dispHelpDesk = true;
              break;
            case "specsaverslogistics":
              this.dispReports = false;
              this.dispTools = true;
              this.dispCitipostOnly = false;
              this.dispPlaceOrder = false;
              this.dispHelpDesk = true;
              break;
            default:

              this.dispReports = false;
              this.dispTools = false;
              this.dispCitipostOnly = false;
              this.dispPlaceOrder = false;
              this.dispHelpDesk = false;
          }
      })

    }

    public ngOnInit(): any {
            this.loadShops();
            this.isRole();   
    }
}
